import styled from 'styled-components'

export const ClearButton = styled.button.attrs({ type: 'button' })`
    & * {
        /* Remove the unnecessary height due to button height being greater than content height. */
        /* Read more: https://stackoverflow.com/a/45424887/8158281 */
        display: block;
    }
`
